import React, { useEffect, useMemo, useState } from "react";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";
import { useSecurityMaster } from "../../context/SecurityMasterContext";
import { useNavigate } from "react-router-dom";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { FiRefreshCw } from "react-icons/fi";
import { usePrediction } from "../../context/PredictionContext";
import { nseIndicesOptions } from "../Helper/Helperdata";
// import { useExport } from "../../context/ExportContext";
import { useExport } from "../../hooks/useExport";
import { useAuth } from "../../context/AuthNewContext";
import { useMarketSnapshot } from "../../context/MarketSnapshotContext";
import { IoMdTrendingDown, IoMdTrendingUp } from "react-icons/io";
import "./TrendAnalysis.css";
const TrendAnalysis = () => {
  const { getLatestNseData, latestNseData } = useMarketIndicators();
  const { user } = useAuth();
  const [changeFilter, setChangeFilter] = useState("all");
  const [volumeFilter, setVolumeFilter] = useState("all");
  // const { downloadIntradayCSV, downloadIntradayExcel, sendReport } =
  //   useExport();
  const { exportCSV, exportExcel, exporting, sendReport } = useExport();

  const {
    dashboardTrendData,
    dashboardTrendLoading,
    dashboardTrendError,
    loadDashboardIndexTrend,
    resetDashboardTrendData,
  } = useMarketSnapshot();
  /* 🔥 NEW FILTER FOR ALPHABETICAL ORDER */
  const [alphaFilter, setAlphaFilter] = useState("all");
  //new sort
  const [closingStrengthSort, setClosingStrengthSort] = useState("none");
  const [reboundStrengthSort, setReboundStrengthSort] = useState("none");
  const [distanceHighSort, setDistanceHighSort] = useState("none");
  const [openDropdown, setOpenDropdown] = useState(false);
  const { getSecurityIds } = useSecurityMaster();
  const [sending, setSending] = useState(false);
  const [filter, setFilter] = useState("All");
  const [recommendationSort, setRecommendationSort] = useState("none");
  const [lastUpdate, setLastUpdate] = useState("");
  const [selectedIndex, setSelectedIndex] = useState("NIFTY 50");

  const { predictionMap, fetchPredictions, loading, error, lastUpdated } =
    usePrediction();
  const [securityData, setSecurityData] = useState("");
  const navigate = useNavigate();

  // const nseIndicesOptions = [
  //   "NIFTY 50",
  //   "NIFTY BANK",
  //   "NIFTY IT",
  //   "NIFTY NEXT 50",
  //   "NIFTY MIDCAP 100",
  // ];

  // ✅ data comes directly from dashboardTrendData
  const trendRows = Object.values(dashboardTrendData || {});

  // ✅ single useEffect — replaces 3 chained effects
  useEffect(() => {
    if (!selectedIndex) return;

    let interval;

    const fetchAll = async () => {
      await loadDashboardIndexTrend({ indexName: selectedIndex });
      setLastUpdate(formatTimestamp());
    };

    fetchAll();

    interval = setInterval(
      () => {
        if (!document.hidden) fetchAll();
      },
      5 * 60 * 1000,
    );

    return () => clearInterval(interval);
  }, [selectedIndex]);

  console.log("Nifty 50 data", latestNseData);
  const indexSymbolData = latestNseData?.data;
  console.log("Index symbol data", indexSymbolData);
  const initialIndex = selectedIndex;
  const dataToRender1 = indexSymbolData?.filter((item) => item?.priority !== 1);
  console.log("Data to render 1", dataToRender1);

  const symbols = useMemo(() => {
    if (!indexSymbolData) return [];
    return indexSymbolData
      .filter((item) => item?.priority !== 1)
      .map((item) => item.symbol);
  }, [indexSymbolData]);
  console.log("symbols", symbols);
  const formatVolume = (volume) => {
    if (volume == null) return "-"; // catches null & undefined

    const num = Number(volume);
    if (!Number.isFinite(num)) return "-";

    return num.toLocaleString("en-IN");
  };

  // (50) ['HDFCBANK', 'ICICIBANK', 'MAXHEALTH', 'INFY', 'RELIANCE', 'BHARTIARTL', 'ITC', 'WIPRO', 'SBIN', 'M&M', 'SUNPHARMA', 'AXISBANK', 'TCS', 'ETERNAL', 'LT', 'SHRIRAMFIN', 'MARUTI', 'APOLLOHOSP', 'TRENT', 'TATASTEEL', 'NTPC', 'BAJFINANCE', 'POWERGRID', 'COALINDIA', 'HINDALCO', 'ASIANPAINT', 'ULTRACEMCO', 'KOTAKBANK', 'BEL', 'EICHERMOT', 'JIOFIN', 'ONGC', 'TITAN', 'ADANIENT', 'INDIGO', 'GRASIM', 'ADANIPORTS', 'HINDUNILVR', 'DRREDDY', 'TMPV', 'HCLTECH', 'BAJAJ-AUTO', 'HDFCLIFE', 'TATACONSUM', 'SBILIFE', 'NESTLEIND', 'CIPLA', 'TECHM', 'JSWSTEEL', 'BAJAJFINSV']
  console.log("Symbols", symbols);
  console.log("symboles length", symbols.length);
  const trendDate = lastUpdated
    ? new Date(
        new Date(lastUpdated).toLocaleString("en-US", {
          timeZone: "Asia/Kolkata",
        }),
      ).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "";
  const normalizedIndexData =
    dataToRender1?.map((item) => ({
      ticker_id: item.symbol,
      company: item.symbol,
      ticker: item.symbol,
      price: item.lastPrice,
      open: item.open,
      close: item.previousClose,
      low: item.dayLow,
      high: item.dayHigh,
      volume: item.totalTradedVolume,
      yearHigh: item.yearHigh,
      percent_change: item.pChange ?? 0,
    })) || [];
  useEffect(() => {
    if (!symbols?.length) return;

    const loadSecurityIds = async () => {
      try {
        const symbolsData = await getSecurityIds(symbols);
        console.log("Security IDs:", symbolsData);
        setSecurityData(symbolsData);

        // use symbolsData here
      } catch (err) {
        console.error("Failed to load security IDs", err);
      }
    };

    loadSecurityIds();
  }, [symbols]);

  console.log("Security Id", securityData);
  const formatTimestamp = () => {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[now.getMonth()];

    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    return `${day}-${month}-${year} ${time} IST`;
  };
  // useEffect(() => {
  //   if (!securityData?.length) return;

  //   const payload = securityData.map((item) => ({
  //     symbol: item.symbol,
  //     securityId: item.security_id,
  //   }));

  //   fetchPredictions(payload);
  // }, [securityData]);
  // useEffect(() => {
  //   if (!securityData?.length) return;

  //   const payload = securityData.map((item) => ({
  //     symbol: item.symbol,
  //     securityId: item.security_id,
  //   }));

  //   // 1️⃣ Initial fetch (cache or stale)
  //   fetchPredictions(payload);

  //   // 2️⃣ Re-fetch after background refresh
  //   const timer = setTimeout(() => {
  //     console.log("🔁 Re-fetching predictions after refresh");
  //     fetchPredictions(payload);
  //   }, 5000);

  //   return () => clearTimeout(timer);
  // }, [securityData]);
  const handleChangeSort = (value) => {
    setChangeFilter(value);
    setVolumeFilter("all");
  };

  const handleVolumeSort = (value) => {
    setVolumeFilter(value);
    setChangeFilter("all");
  };
  /* 🔥 HANDLE ALPHABETICAL SORT */
  const handleAlphaSort = (value) => {
    setAlphaFilter(value);
    setChangeFilter("all");
    setVolumeFilter("all");
  };
  //   const filteredData = [...baseData]?.sort((a, b) => {
  //   // % CHANGE SORT
  //   if (changeFilter === "high") return b.percent_change - a.percent_change;

  //   if (changeFilter === "low") return a.percent_change - b.percent_change;

  //   // VOLUME SORT
  //   if (volumeFilter === "high") return b.volume - a.volume;
  //   if (volumeFilter === "low") return a.volume - b.volume;

  //   return 0;
  // });

  // console.log("PRediction am", predictionMap);
  // const resistData = predictionMap?.hist_data;
  // console.log("Resistnce data", resistData);
  // const resistLow = resistData?.low;
  // const resistHigh = resistData?.high;
  // const resistClose = resistData?.close;
  // const resistOpen = resistData?.open;
  // const resDailyLow = resistLow?.[resistLow?.length - 1];
  // const resWeeklyLow = resistLow?.[0];
  // const resDailyHigh = resistHigh?.[resistHigh?.length - 1];
  // const resWeeklyHigh = resistHigh?.[0];
  // const resDailyClose = resistClose?.[resistClose?.length - 1];
  // const resWeeklyClose = resistClose?.[0];
  // const resDailyOpen = resistOpen?.[resistOpen?.length - 1];
  // const resWeeklyOpen = resistOpen?.[0];

  const calculatePivots = (open, high, low, close) => {
    const range = high - low;

    const classicP = (high + low + close) / 3;
    const classic = {
      R3: high + 2 * (classicP - low),
      R2: classicP + range,
      R1: 2 * classicP - low,
      P: classicP,

      S1: 2 * classicP - high,
      S2: classicP - range,
      S3: low - 2 * (high - classicP),
    };

    // Fibonacci
    const fib = {
      R1: classicP + range * 0.382,
      R2: classicP + range * 0.618,
      R3: classicP + range * 1.0,
      P: classicP,
      S1: classicP - range * 0.382,
      S2: classicP - range * 0.618,
      S3: classicP - range * 1.0,
    };

    // Camarilla
    const cam = {
      R1: close + range * 1.0833,
      R2: close + range * 1.1666,
      R3: close + range * 1.25,
      P: close,
      S1: close - range * 1.0833,
      S2: close - range * 1.1666,
      S3: close - range * 1.25,
    };

    // Woodie
    const woodieP = (high + low + 2 * close) / 4;
    const woodie = {
      R1: 2 * woodieP - low,
      R2: woodieP + range,
      R3: high + 2 * (woodieP - low),
      P: woodieP,
      S1: 2 * woodieP - high,
      S2: woodieP - range,
      S3: low - 2 * (high - woodieP),
    };

    // Demark
    let demPivot;
    if (close < open) {
      demPivot = (high + 2 * low + close) / 4;
    } else if (close > open) {
      demPivot = (2 * high + low + close) / 4;
    } else {
      demPivot = (high + low + 2 * close) / 4;
    }
    const demark = {
      P: demPivot,
      R1: demPivot + range,
      S1: demPivot - range,
    };

    return { classic, fib, cam, woodie, demark };
  };

  // const resWeekly = calculatePivots(
  //   resWeeklyOpen,
  //   resWeeklyHigh,
  //   resWeeklyLow,
  //   resWeeklyClose,
  // );
  // const resDaily = calculatePivots(
  //   resDailyOpen,
  //   resDailyHigh,
  //   resDailyLow,
  //   resDailyClose,
  // );
  // console.log("ResWeekly", resWeekly);
  // console.log("ResDaily", resDaily);

  const getClassicR1S1 = (symbol) => {
    const histData = predictionMap?.[symbol]?.hist_data;
    console.log("HistData", histData);
    if (!histData) return null;

    const { open, high, low, close } = histData;

    if (!open?.length || !high?.length || !low?.length || !close?.length) {
      return null;
    }

    const o = open.at(-1);
    const h = high.at(-1);
    const l = low.at(-1);
    const c = close.at(-1);

    if ([o, h, l, c].some((v) => typeof v !== "number")) return null;

    const pivots = calculatePivots(o, h, l, c);

    return {
      R1: pivots.classic.R1,
      S1: pivots.classic.S1,
    };
  };

  // const getHistData = (symbol) => {
  //   console.log("symbol", symbol);
  //   console.log("Synbol hist data", predictionMap?.[symbol]?.hist_data);
  //   return predictionMap?.[symbol]?.hist_data;
  // };
  const getBgColor = (text) => {
    if (text === "Buy" || text === "BUY" || text === "Bullish") {
      return "#249966";
    } else if (text === "Sell" || text === "SELL" || text === "Bearish") {
      return "#f87171";
    } else {
      return "#fbbf24";
    }
  };
  // const handleIndexSelect = (e) => {
  //   const value = e.target.value;
  //   console.log("value seleect", value);
  //   setSelectedIndex(value);

  //   if (!value) return;

  //   // getNseIndexData(value);
  //   getLatestNseData(value);
  // };
  const handleIndexSelect = (e) => {
    const value = e.target.value;
    if (!value) return;
    resetDashboardTrendData();
    setSelectedIndex(value);
  };

  useEffect(() => {
    if (!selectedIndex) return;
    localStorage.setItem("selectedIndex", selectedIndex);
    getLatestNseData(selectedIndex);
  }, [selectedIndex]);
  const date = new Date();
  console.log("Date", date);
  console.log("Last Updted", lastUpdated);
  const checkPercent = (value) => {
    if (value >= 75) {
      return "#249966";
    } else if (value >= 30 && value < 75) {
      return "#fbbf24";
    } else {
      return "#f87171";
    }
  };

  const checkValues = (value) => {
    if (value > 60 && value < 100) {
      return "#249966";
    } else if (value > 31 && value < 59) {
      return "#fbbf24";
    } else {
      return "#f87171";
    }
  };
  const distanceToHighValues = (value) => {
    if (value >= 0 && value <= 20) {
      return "#249966"; // 🟢 Close near highs, bullish
    } else if (value >= 21 && value <= 60) {
      return "#fbbf24"; // 🟡 Mid-range close, neutral
    } else {
      return "#f87171"; // 🔴 Close near lows, bearish
    }
  };
  const InfoTooltip = ({ text }) => {
    const textItem = text?.text;
    return (
      <span className="table-tooltip-wrapper">
        {textItem?.map((item) => (
          <>
            ⓘ
            <span className="table-tooltip-content" key={item?.id}>
              {item?.text}
            </span>
          </>
        ))}
      </span>
    );
  };

  const closeStrength = [
    {
      id: 1,
      text: "🟢 Above 75% → Strong buying at close, buyers dominated, bullish for next day",
    },
    { id: 2, text: "🟡 30% – 75% → Balanced close, neutral momentum" },
    {
      id: 3,
      text: "🔴 Below 30% → Strong selling at close, sellers dominated, bearish signal",
    },
  ];
  const reboundStrength = [
    {
      id: 1,
      text: "🟢 60% – 100% → Strong close near highs, bullish for next day",
    },
    { id: 2, text: "🟡 31% – 59% → Balanced close, neutral momentum" },
    { id: 3, text: "🔴 0% – 30% → Close near lows, strong selling pressure" },
  ];
  const distanceToHigh = [
    { id: 1, text: "🟢 0% – 20% → Close near highs, strong bullish momentum" },
    { id: 2, text: "🟡 21% – 60% → Mid-range close, neutral momentum" },
    { id: 3, text: "🔴 61% – 100% → Close near lows, strong selling pressure" },
  ];
  // const handleRefresh = async () => {
  //   try {
  //     // refresh NSE data
  //     await getLatestNseData(selectedIndex);

  //     // refresh predictions
  //     if (securityData?.length) {
  //       const payload = securityData.map((item) => ({
  //         symbol: item.symbol,
  //         securityId: item.security_id,
  //       }));

  //       await fetchPredictions(payload);
  //     }

  //     // update timestamp
  //     setLastUpdate(formatTimestamp());

  //     console.log("🔄 Data refreshed");
  //   } catch (err) {
  //     console.error("Refresh failed", err);
  //   }
  // };

  //final data to render

  const handleRefresh = async () => {
    try {
      await loadDashboardIndexTrend({ indexName: selectedIndex });
      setLastUpdate(formatTimestamp());
    } catch (err) {
      console.error("Refresh failed", err);
    }
  };

  const sortedData = [...normalizedIndexData].sort((a, b) => {
    const recA = predictionMap[a.company]?.prediction;
    const recB = predictionMap[b.company]?.prediction;

    const order = { Buy: 1, Neutral: 2, Sell: 3 };

    if (recommendationSort === "asc") {
      return (order[recA] || 99) - (order[recB] || 99);
    }
    if (recommendationSort === "desc") {
      return (order[recB] || 99) - (order[recA] || 99);
    }

    // ✅ USE SAME DATA AS UI
    const histA = predictionMap[a.company]?.hist_data;
    const histB = predictionMap[b.company]?.hist_data;

    // 🔥 Important: push empty data to bottom
    if (!histA && !histB) return 0;
    if (!histA) return 1;
    if (!histB) return -1;

    const highA = histA.high?.at(-1) || 0;
    const lowA = histA.low?.at(-1) || 0;
    const closeA = histA.close?.at(-1) || 0;
    const openA = histA.open?.at(-1) || 0;

    const highB = histB.high?.at(-1) || 0;
    const lowB = histB.low?.at(-1) || 0;
    const closeB = histB.close?.at(-1) || 0;
    const openB = histB.open?.at(-1) || 0;

    const rangeA = highA - lowA || 1;
    const rangeB = highB - lowB || 1;

    const closingA = ((closeA - lowA) / rangeA) * 100;
    const closingB = ((closeB - lowB) / rangeB) * 100;

    const reboundA = ((Math.min(closeA, openA) - lowA) / rangeA) * 100;
    const reboundB = ((Math.min(closeB, openB) - lowB) / rangeB) * 100;

    const distA = ((highA - closeA) / rangeA) * 100;
    const distB = ((highB - closeB) / rangeB) * 100;

    // 🔥 Closing Strength
    if (closingStrengthSort === "high") return closingB - closingA;
    if (closingStrengthSort === "low") return closingA - closingB;

    // 🔥 Rebound Strength
    if (reboundStrengthSort === "high") return reboundB - reboundA;
    if (reboundStrengthSort === "low") return reboundA - reboundB;

    // 🔥 Distance to High
    if (distanceHighSort === "high") return distB - distA;
    if (distanceHighSort === "low") return distA - distB;

    return 0;
  });
  const sortCompanyAsc = () => {
    setAlphaFilter("az");
    setChangeFilter("all");
    setVolumeFilter("all");
  };

  const sortCompanyDesc = () => {
    setAlphaFilter("za");
    setChangeFilter("all");
    setVolumeFilter("all");
  };

  const sortPercentHigh = () => {
    setChangeFilter("high");
    setAlphaFilter("all");
  };

  const sortPercentLow = () => {
    setChangeFilter("low");
    setAlphaFilter("all");
  };
  const sortRecommendationAsc = () => {
    setRecommendationSort("asc");
    setChangeFilter("all");
    setAlphaFilter("all");
    setVolumeFilter("all");
  };

  const sortRecommendationDesc = () => {
    setRecommendationSort("desc");
    setChangeFilter("all");
    setAlphaFilter("all");
    setVolumeFilter("all");
  };
  const resetAllSorts = () => {
    setClosingStrengthSort("none");
    setReboundStrengthSort("none");
    setDistanceHighSort("none");
    setChangeFilter("all");
    setVolumeFilter("all");
    setAlphaFilter("all");
    setRecommendationSort("none");
  };

  // 🔹 Closing Strength
  const sortClosingHigh = () => {
    resetAllSorts();
    setClosingStrengthSort("high");
  };

  const sortClosingLow = () => {
    resetAllSorts();
    setClosingStrengthSort("low");
  };

  // 🔹 Rebound Strength
  const sortReboundHigh = () => {
    resetAllSorts();
    setReboundStrengthSort("high");
  };

  const sortReboundLow = () => {
    resetAllSorts();
    setReboundStrengthSort("low");
  };

  // 🔹 Distance to High
  const sortDistanceHigh = () => {
    resetAllSorts();
    setDistanceHighSort("high");
  };

  const sortDistanceLow = () => {
    resetAllSorts();
    setDistanceHighSort("low");
  };

  //send report
  const handleSendReport = async () => {
    try {
      setSending(true);

      await sendReport({
        type: "eod",
        email: user?.userID, // 🔥 from auth
      });

      window.alert("📧 Report sent to your email!");
    } catch (err) {
      window.alert("❌ Failed to send report");
    } finally {
      setSending(false);
    }
  };
  // useEffect(() => {
  //   if (latestNseData) {
  //     setLastUpdate(formatTimestamp());
  //   }
  // }, [latestNseData]);
  useEffect(() => {
    const handleClickOutside = () => {
      setOpenDropdown(false);
    };

    if (openDropdown) {
      window.addEventListener("click", handleClickOutside);
    }

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [openDropdown]);

  // 🔹 Convert hist_data → candles
  const buildCandlesFromHist = (histData) => {
    if (!histData) return [];

    const {
      open = [],
      high = [],
      low = [],
      close = [],
      timestamp = [],
    } = histData;

    return close.map((_, i) => ({
      time: Math.floor(new Date(timestamp[i]).getTime() / 1000), // ✅ FIX
      open: open[i],
      high: high[i],
      low: low[i],
      close: close[i],
    }));
  };

  // 🔹 Get LAST UT signal
  const getUTLastSignal = (histData) => {
    const candles = buildCandlesFromHist(histData);
    if (!candles.length) return null;

    const { signals } = calculateUTBotWithSignals(candles);
    if (!signals.length) return null;

    return signals[signals.length - 1];
  };

  const calculateUTBotWithSignals = (candles, key = 3, atrPeriod = 10) => {
    if (!candles || candles.length < 2) return { ut: [], signals: [] };

    const tr = [];

    // 🔹 True Range
    for (let i = 1; i < candles.length; i++) {
      const high = candles[i].high;
      const low = candles[i].low;
      const prevClose = candles[i - 1].close;

      tr.push(
        Math.max(
          high - low,
          Math.abs(high - prevClose),
          Math.abs(low - prevClose),
        ),
      );
    }

    // 🔹 ATR (RMA like Pine)
    const atr = [];
    for (let i = 0; i < tr.length; i++) {
      if (i === 0) atr.push(tr[0]);
      else atr.push((atr[i - 1] * (atrPeriod - 1) + tr[i]) / atrPeriod);
    }

    atr.unshift(atr[0]); // align with candles

    let xATRTrailingStop = [];
    let signals = [];

    let prevStop = 0;
    let prevPos = 0;

    for (let i = 0; i < candles.length; i++) {
      const src = candles[i].close;

      // 🔥 FIX 1: proper nz() behavior like Pine
      const prevSrc = i === 0 ? candles[i].close : candles[i - 1].close;

      const loss = key * (atr[i] || 0);

      let stop;

      if (i === 0) {
        stop = src;
      } else {
        if (src > prevStop && prevSrc > prevStop) {
          stop = Math.max(prevStop, src - loss);
        } else if (src < prevStop && prevSrc < prevStop) {
          stop = Math.min(prevStop, src + loss);
        } else {
          stop = src > prevStop ? src - loss : src + loss;
        }
      }

      // 🔥 POSITION (same as Pine)
      let pos = prevPos;

      if (prevSrc < prevStop && src > prevStop) pos = 1;
      else if (prevSrc > prevStop && src < prevStop) pos = -1;

      // 🔥 FIX 2: correct crossover logic (use prevStop vs current stop)
      if (i > 0 && i < candles.length - 1) {
        const crossedUp =
          (i === 1 && src > stop) || // 🔥 FIRST BAR FIX (09:16 BUY)
          (prevSrc < prevStop && src > stop);

        const crossedDown =
          (i === 1 && src < stop) || // 🔥 FIRST BAR FIX
          (prevSrc > prevStop && src < stop);

        if (crossedUp && pos !== 1) {
          signals.push({
            time: candles[i].time,
            position: "belowBar",
            color: "green",
            shape: "arrowUp",
            text: "Bullish",
          });
          pos = 1;
        }

        if (crossedDown && pos !== -1) {
          signals.push({
            time: candles[i].time,
            position: "aboveBar",
            color: "red",
            shape: "arrowDown",
            text: "Bearish",
          });
          pos = -1;
        }
      }

      xATRTrailingStop.push({
        time: candles[i].time,
        value: stop,
      });

      prevStop = stop;
      prevPos = pos;
    }

    return {
      ut: xATRTrailingStop,
      signals,
    };
  };

  // 🔹 Format time
  const formatTime = (t) =>
    new Date(t * 1000).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
    });

  const lastDate = trendRows?.[0]?.dates?.at(-1);
  const formattedDate = new Date(lastDate).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  console.log("Prediction Map", predictionMap);
  console.log("Dashboard trend data", dashboardTrendData);

  const normalizeSignal = (signal) => {
    if (!signal) return "Neutral";

    const value = signal.toUpperCase();

    if (value === "BUY" || value === "BULLISH") return "Bullish";
    if (value === "SELL" || value === "BEARISH") return "Bearish";

    return "Neutral";
  };

  const getSignalRank = (signal) => {
    const rank = {
      Bullish: 1,
      Neutral: 2,
      Bearish: 3,
    };

    return rank[normalizeSignal(signal)] || 99;
  };
  const getTrendMetrics = (stock) => {
    const histData = stock?.hist_data;

    const ltp = Number(histData?.close?.at(-1)) || 0;
    const prevClose = Number(histData?.close?.at(-2)) || 0;
    const low = Number(histData?.low?.at(-1)) || 0;
    const high = Number(histData?.high?.at(-1)) || 0;
    const open = Number(histData?.open?.at(-1)) || 0;

    const range = high - low || 1;

    const percentChange = prevClose ? ((ltp - prevClose) / prevClose) * 100 : 0;

    const closingStrength = ((ltp - low) / range) * 100;

    const reboundStrength = ((Math.min(ltp, open) - low) / range) * 100;

    const distanceToHigh = ((high - ltp) / range) * 100;

    return {
      percentChange,
      closingStrength,
      reboundStrength,
      distanceToHigh,
    };
  };
  const trendTableData = [...trendRows].sort((a, b) => {
    const symbolA = a?.symbol || "";
    const symbolB = b?.symbol || "";

    const metricsA = getTrendMetrics(a);
    const metricsB = getTrendMetrics(b);

    if (alphaFilter === "az") {
      return symbolA.localeCompare(symbolB);
    }

    if (alphaFilter === "za") {
      return symbolB.localeCompare(symbolA);
    }

    if (recommendationSort === "asc") {
      return getSignalRank(a?.prediction) - getSignalRank(b?.prediction);
    }

    if (recommendationSort === "desc") {
      return getSignalRank(b?.prediction) - getSignalRank(a?.prediction);
    }

    if (changeFilter === "high") {
      return metricsB.percentChange - metricsA.percentChange;
    }

    if (changeFilter === "low") {
      return metricsA.percentChange - metricsB.percentChange;
    }

    if (closingStrengthSort === "high") {
      return metricsB.closingStrength - metricsA.closingStrength;
    }

    if (closingStrengthSort === "low") {
      return metricsA.closingStrength - metricsB.closingStrength;
    }

    if (reboundStrengthSort === "high") {
      return metricsB.reboundStrength - metricsA.reboundStrength;
    }

    if (reboundStrengthSort === "low") {
      return metricsA.reboundStrength - metricsB.reboundStrength;
    }

    if (distanceHighSort === "high") {
      return metricsB.distanceToHigh - metricsA.distanceToHigh;
    }

    if (distanceHighSort === "low") {
      return metricsA.distanceToHigh - metricsB.distanceToHigh;
    }
    if (recommendationSort === "asc") {
      return getSignalRank(a?.prediction) - getSignalRank(b?.prediction);
    }

    if (recommendationSort === "desc") {
      return getSignalRank(b?.prediction) - getSignalRank(a?.prediction);
    }

    return 0;
  });

  const EXPORT_COLUMNS = [
    { header: "Symbol", key: "symbol", width: 15 },
    { header: "Company", key: "company", width: 20 },
    { header: "LTP", key: "ltp", width: 12 },
    { header: "RSI & MACD Trend", key: "prediction", width: 16 },
    { header: "Low", key: "low", width: 12 },
    { header: "High", key: "high", width: 12 },
    { header: "Open", key: "open", width: 12 },
    { header: "Prev Close", key: "prev_close", width: 12 },
    { header: "% Change", key: "percent_change", width: 12 },
    { header: "R1", key: "r1", width: 12 },
    { header: "S1", key: "s1", width: 12 },
    { header: "Closing Strength", key: "closing_strength", width: 16 },
    { header: "Rebound Strength", key: "rebound_strength", width: 16 },
    { header: "Distance to High", key: "distance_high", width: 16 },
  ];
  const buildExportRows = () => {
    return (
      trendTableData
        ?.filter((stock) => {
          if (filter === "All") return true;
          return normalizeSignal(stock?.prediction) === filter;
        })
        ?.map((stock) => {
          const hist = stock?.hist_data;
          const tm = stock?.trend_metrics;

          // Fall back across both shapes the UI uses
          const ltp = tm?.ltp ?? hist?.close?.at(-1) ?? "";
          const low = tm?.low ?? hist?.low?.at(-1) ?? "";
          const high = tm?.high ?? hist?.high?.at(-1) ?? "";
          const open = tm?.open ?? hist?.open?.at(-1) ?? "";
          const prevClose = stock?.prev_close ?? hist?.close?.at(-2) ?? "";

          const range = high && low ? high - low : 0;

          const percentChange =
            prevClose && ltp
              ? Number((((ltp - prevClose) / prevClose) * 100).toFixed(2))
              : "";

          const closingStrength =
            tm?.closingStrength ??
            (range && ltp
              ? Number((((ltp - low) / range) * 100).toFixed(2))
              : "");

          const reboundStrength =
            range && ltp && open
              ? Number((((Math.min(ltp, open) - low) / range) * 100).toFixed(2))
              : "";

          const distanceHigh =
            tm?.distanceToHigh ??
            (range && ltp
              ? Number((((high - ltp) / range) * 100).toFixed(2))
              : "");

          const r1 = stock?.resDaily?.classic?.R1;
          const s1 = stock?.resDaily?.classic?.S1;

          return {
            symbol: stock?.symbol || "",
            company: stock?.company || "",
            ltp,
            prediction: stock?.prediction || "",
            low,
            high,
            open,
            prev_close: prevClose,
            percent_change: percentChange,
            r1: r1 ? Number(r1).toFixed(2) : "",
            s1: s1 ? Number(s1).toFixed(2) : "",
            closing_strength: closingStrength,
            rebound_strength: reboundStrength,
            distance_high: distanceHigh,
          };
        }) || []
    );
  };
  const handleDownloadCSV = () =>
    exportCSV({
      rows: buildExportRows(),
      columns: EXPORT_COLUMNS,
      filename: `${selectedIndex}_eod_trend`,
      sheetName: selectedIndex,
    });

  const handleDownloadExcel = () =>
    exportExcel({
      rows: buildExportRows(),
      columns: EXPORT_COLUMNS,
      filename: `${selectedIndex}_eod_trend`,
      sheetName: selectedIndex,
    });
  return (
    <>
      {/* <div className="export-btn-container">
        <div className="trend-export">
          <div className="back-btn">
            <button className="rec-btn" onClick={() => navigate(-1)}>
              Back
            </button>
          </div>
          <div className="select-option dropdown select-index-dropdown">
            <label className="test-page-label" style={{ textAlign: "center" }}>
              Choose Index
            </label>
            <select
              onChange={handleIndexSelect}
              value={selectedIndex}
              // style={{ width: "150px" }}
              className="stocktest-inner-select trend-analysis-select"
            >
              <option value="">Select</option>
              {nseIndicesOptions?.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
        </div>
        <h1 className="stocktest-h1 trend-analysis-head">{selectedIndex}</h1>

        <div className="export-files">
          <button className="rec-btn" onClick={handleSendReport}>
            {sending ? "Sending..." : "📧 Email Report"}
          </button>

         
          <div className="download-dropdown">
            <button
              className="rec-btn"
              onClick={(e) => {
                setOpenDropdown((prev) => !prev);

                e.stopPropagation();
              }}
            >
              Download ⬇
            </button>

            {openDropdown && (
              <div className="download-menu">
                <div
                  className="download-item"
                  onClick={() => {
                    downloadIntradayCSV("eod");
                    setOpenDropdown(false);
                  }}
                >
                  Download CSV
                </div>

                <div
                  className="download-item"
                  onClick={() => {
                    downloadIntradayExcel("eod");
                    setOpenDropdown(false);
                  }}
                >
                  Download Excel
                </div>
              </div>
            )}
          </div>
        </div>
      </div> */}

      {/* 
      <div className="daily-trend-head">
        <div className="last-updated-head">
          {formattedDate && <span>As on {formattedDate}</span>}
          <FiRefreshCw
            onClick={handleRefresh}
            size={18}
            style={{
              cursor: "pointer",
              transition: "0.2s",
            }}
            onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
            onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
          />
        </div>
      </div> */}
      {/* <div className="stock-table-container">
       

        <div
          className="stock-responsive-table"
          style={{
            width: "100%",
            overflowX: "auto",
            WebkitOverflowScrolling: "touch",
          }}
        >
          <table className="stock-table">
            <thead>
              <tr>
               
                <th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    Company or Ticker
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                    >
                      <FaChevronUp size={10} onClick={sortCompanyAsc} />
                      <FaChevronDown size={10} onClick={sortCompanyDesc} />
                    </div>
                  </div>
                </th>
                <th>LTP</th>

                <th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    RSI & MACD Trend
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                    >
                      <FaChevronUp size={10} onClick={sortRecommendationAsc} />
                      <FaChevronDown
                        size={10}
                        onClick={sortRecommendationDesc}
                      />
                    </div>
                  </div>

                
                </th>
               
                <th>Low</th>
                <th>High</th>
                <th>Open</th>
                <th>Prev Close</th>
              
                <th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    % Change
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                    >
                      <FaChevronUp size={10} onClick={sortPercentHigh} />
                      <FaChevronDown size={10} onClick={sortPercentLow} />
                    </div>
                  </div>
                </th>

                
                <th>R1</th>
                <th>S1</th>

                
                <th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    Closing Strength <InfoTooltip text={closeStrength} />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                    >
                      <FaChevronUp size={10} onClick={sortClosingHigh} />
                      <FaChevronDown size={10} onClick={sortClosingLow} />
                    </div>
                  </div>
                </th>

               
                <th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    Rebound Strength <InfoTooltip text={reboundStrength} />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                    >
                      <FaChevronUp size={10} onClick={sortReboundHigh} />
                      <FaChevronDown size={10} onClick={sortReboundLow} />
                    </div>
                  </div>
                </th>

               
                <th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    Distance to High <InfoTooltip text={distanceToHigh} />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                    >
                      <FaChevronUp size={10} onClick={sortDistanceHigh} />
                      <FaChevronDown size={10} onClick={sortDistanceLow} />
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
          
            <tbody>
              {trendTableData
                ?.filter((stock) => {
                  if (filter === "All") return true;
                  return stock?.prediction === filter;
                })
                .map((stock) => {
                  const histData = stock?.hist_data;

                  const ltp = histData?.close?.at(-1);
                  const prevClose = histData?.close?.at(-2);
                  const low = histData?.low?.at(-1);
                  const high = histData?.high?.at(-1);
                  const open = histData?.open?.at(-1);
                  const r1 = stock?.resDaily?.classic?.R1?.toFixed(2);
                  const s1 = stock?.resDaily?.classic?.S1?.toFixed(2);

                  const change = prevClose
                    ? (((ltp - prevClose) / prevClose) * 100).toFixed(2)
                    : "-";
                  const symbol = stock?.symbol;
                  const security_id = stock?.security_id;
                  return (
                    <tr
                      key={stock.symbol}
                      className="stock-row"
                      onClick={() =>
                        // navigate(`/stockInfo/${stock.symbol}`)
                        navigate(`/stockdetail/${symbol}/${security_id}`)
                      }
                    >
                      <td>{stock.symbol}</td>

                      <td>₹{ltp ?? "-"}</td>

                      <td>
                        <button
                          className="rec-btn"
                          style={{
                            backgroundColor: getBgColor(stock?.prediction),
                          }}
                        >
                          {stock?.prediction || "Refreshing"}
                        </button>
                      </td>

                     

                      <td>₹{low ?? "-"}</td>
                      <td>₹{high ?? "-"}</td>
                      <td>₹{open ?? "-"}</td>
                      <td>₹{prevClose ?? "-"}</td>

                      <td
                        style={{
                          color: change >= 0 ? "#249966" : "#f87171",
                          fontWeight: "bold",
                        }}
                      >
                        {change}%
                      </td>

                     

                      <td>{`₹${r1}` ?? "-"}</td>
                      <td>{`₹${s1}` ?? "-"}</td>

                      <td
                        style={{
                          fontWeight: "bold",
                          color: checkPercent(
                            (((ltp - low) / (high - low)) * 100).toFixed(2),
                          ),
                        }}
                      >
                        {(((ltp - low) / (high - low)) * 100).toFixed(2)}%
                      </td>

                      <td
                        style={{
                          color: checkValues(
                            (
                              ((Math.min(ltp, open) - low) / (high - low)) *
                              100
                            ).toFixed(2),
                          ),
                        }}
                      >
                        {(
                          ((Math.min(ltp, open) - low) / (high - low)) *
                          100
                        ).toFixed(2)}
                        %
                      </td>

                      <td
                        style={{
                          color: distanceToHighValues(
                            (((high - ltp) / (high - low)) * 100).toFixed(2),
                          ),
                        }}
                      >
                        {(((high - ltp) / (high - low)) * 100).toFixed(2)}%
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>

      
        <div className="stock-mobile-card-wrapper">
          {trendTableData
            ?.filter((stock) => {
              if (filter === "All") return true;
              return stock?.prediction === filter;
            })
            ?.map((stock) => {
              const histData = stock?.hist_data;

              const ltp = histData?.close?.at(-1);
              const prevClose = histData?.close?.at(-2);
              const low = histData?.low?.at(-1);
              const high = histData?.high?.at(-1);
              const open = histData?.open?.at(-1);

              const r1 = stock?.resDaily?.classic?.R1;
              const s1 = stock?.resDaily?.classic?.S1;

              const symbol = stock?.symbol;
              const security_id = stock?.security_id;

              const range = high && low ? high - low : 0;

              const change =
                prevClose && ltp
                  ? Number((((ltp - prevClose) / prevClose) * 100).toFixed(2))
                  : null;

              const closingStrength =
                range && ltp
                  ? Number((((ltp - low) / range) * 100).toFixed(2))
                  : null;

              const reboundStrength =
                range && ltp && open
                  ? Number(
                      (((Math.min(ltp, open) - low) / range) * 100).toFixed(2),
                    )
                  : null;

              const distanceHigh =
                range && ltp
                  ? Number((((high - ltp) / range) * 100).toFixed(2))
                  : null;

              return (
                <div
                  key={symbol}
                  className="stock-mobile-card"
                  style={{
                    borderLeft: `4px solid ${getBgColor(stock?.prediction)}`,
                  }}
                  onClick={() =>
                    navigate(`/stockdetailpage/${symbol}/${security_id}`)
                  }
                >
                  <div className="stock-mobile-card-header">
                    <span className="stock-mobile-company">{symbol}</span>

                    <span
                      className="stock-mobile-reco"
                      style={{
                        backgroundColor: getBgColor(stock?.prediction),
                      }}
                    >
                      {stock?.prediction || "Refreshing"}
                    </span>
                  </div>

                  <div className="stock-mobile-card-grid">
                    <div>
                      <p className="label">LTP</p>
                      <span>₹{ltp ?? "-"}</span>
                    </div>

                    <div>
                      <p className="label">% Change</p>
                      <span
                        style={{
                          color: change >= 0 ? "#249966" : "#f87171",
                          fontWeight: "700",
                        }}
                      >
                        {change !== null ? `${change}%` : "-"}
                      </span>
                    </div>

                    <div>
                      <p className="label">Open</p>
                      <span>₹{open ?? "-"}</span>
                    </div>

                    <div>
                      <p className="label">Prev Close</p>
                      <span>₹{prevClose ?? "-"}</span>
                    </div>

                    <div>
                      <p className="label">Low</p>
                      <span>₹{low ?? "-"}</span>
                    </div>

                    <div>
                      <p className="label">High</p>
                      <span>₹{high ?? "-"}</span>
                    </div>

                    <div>
                      <p className="label">R1</p>
                      <span style={{ color: "#249966", fontWeight: "700" }}>
                        {r1 ? `₹${Number(r1).toFixed(2)}` : "-"}
                      </span>
                    </div>

                    <div>
                      <p className="label">S1</p>
                      <span style={{ color: "#f87171", fontWeight: "700" }}>
                        {s1 ? `₹${Number(s1).toFixed(2)}` : "-"}
                      </span>
                    </div>

                    <div>
                      <p className="label">Closing Strength</p>
                      <span
                        style={{
                          color:
                            closingStrength !== null
                              ? checkPercent(closingStrength)
                              : "#64748b",
                          fontWeight: "700",
                        }}
                      >
                        {closingStrength !== null ? `${closingStrength}%` : "-"}
                      </span>
                    </div>

                    <div>
                      <p className="label">Rebound Strength</p>
                      <span
                        style={{
                          color:
                            reboundStrength !== null
                              ? checkValues(reboundStrength)
                              : "#64748b",
                          fontWeight: "700",
                        }}
                      >
                        {reboundStrength !== null ? `${reboundStrength}%` : "-"}
                      </span>
                    </div>

                    <div>
                      <p className="label">Distance to High</p>
                      <span
                        style={{
                          color:
                            distanceHigh !== null
                              ? distanceToHighValues(distanceHigh)
                              : "#64748b",
                          fontWeight: "700",
                        }}
                      >
                        {distanceHigh !== null ? `${distanceHigh}%` : "-"}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div> */}

      {/* New code */}

      <main className="trendpro-page">
        {/* <section className="trendpro-header"> */}
        <div className="index-row">
          <>
            <div className="select-option dropdown testpage-inner-dropdown">
              <label className="test-page-label">
                Choose Index
                {/* <InfoTooltip text={DASHTOOL?.indexSelector} /> */}
              </label>

              <div className="select-span-index">
                <select
                  className="test-select"
                  onChange={handleIndexSelect}
                  value={selectedIndex}
                >
                  <option value="">Select</option>
                  {nseIndicesOptions?.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="trendpro-actions">
              <button onClick={handleSendReport}>
                {sending ? "Sending..." : "📧 Email Report"}
              </button>

              <div className="trendpro-download">
                <button
                  onClick={(e) => {
                    setOpenDropdown((prev) => !prev);
                    e.stopPropagation();
                  }}
                >
                  Download ⬇
                </button>

                {openDropdown && (
                  // <div className="trendpro-download-menu">
                  //   <div
                  //     onClick={() => {
                  //       downloadIntradayCSV("eod");
                  //       setOpenDropdown(false);
                  //     }}
                  //   >
                  //     Download CSV
                  //   </div>

                  //   <div
                  //     onClick={() => {
                  //       downloadIntradayExcel("eod");
                  //       setOpenDropdown(false);
                  //     }}
                  //   >
                  //     Download Excel
                  //   </div>
                  // </div>
                  <div className="trendpro-download-menu">
                    <div
                      onClick={() => {
                        handleDownloadCSV(); // was downloadIntradayCSV("eod")
                        setOpenDropdown(false);
                      }}
                    >
                      Download CSV
                    </div>

                    <div
                      onClick={() => {
                        handleDownloadExcel(); // was downloadIntradayExcel("eod")
                        setOpenDropdown(false);
                      }}
                    >
                      Download Excel
                    </div>
                  </div>
                )}
              </div>
              {/* <div style={{ display: "flex", gap: "2px" }}> */}
              {/* <button onClick={() => navigate("/screener/openhigh")}>
                Open High
              </button>
              <button onClick={() => navigate("/screener/openlow")}>
                Open Low
              </button>
              <button onClick={() => navigate("/smartmoney")}>
                Smart Money
              </button>
              <button onClick={() => navigate("/crossovermomentum")}>
                Crossover
              </button> */}
              {/* <button onClick={() => navigate("/tradedeal")}>Trade1</button> */}
              {/* <button onClick={() => navigate("/strategy")}>Trade2</button> */}

              {/* </div> */}
              {/* <div>
                <button onClick={() => navigate("/screener/openhigh")}>
                  Open High
                </button>
                <button onClick={() => navigate("/screener/openlow")}>
                  Open Low
                </button>
                <button onClick={() => navigate("/tradedeal")}>Trade</button>
              </div> */}
            </div>
          </>
        </div>
        {/* </section> */}

        <section className="trendpro-meta-row">
          {formattedDate && <span>As on {formattedDate}</span>}
          <FiRefreshCw
            onClick={handleRefresh}
            size={18}
            style={{
              cursor: "pointer",
              transition: "0.2s",
            }}
            onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
            onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
          />
          {/* {lastUpdate && <span>Last refreshed {lastUpdate}</span>} */}
        </section>

        {dashboardTrendLoading && trendTableData?.length === 0 && (
          <section className="trendpro-loading-card">
            Fetching EOD Trend Data...
          </section>
        )}

        {dashboardTrendError && (
          <section className="trendpro-error-card">
            {dashboardTrendError}
          </section>
        )}

        {trendTableData?.length > 0 && (
          <>
            <section className="trendpro-table-card">
              <div className="trendpro-table-title">
                <div>
                  <h2>{selectedIndex} EOD Trend</h2>
                </div>

                <span>{trendTableData?.length || 0} Stocks</span>
              </div>

              <div className="trendpro-table-wrap">
                <table className="trendpro-table stock-table">
                  <thead>
                    <tr>
                      <th>
                        <div className="trendpro-sort-head">
                          Company or Ticker
                          <span>
                            <FaChevronUp size={10} onClick={sortCompanyAsc} />
                            <FaChevronDown
                              size={10}
                              onClick={sortCompanyDesc}
                            />
                          </span>
                        </div>
                      </th>

                      <th>LTP</th>

                      <th>
                        <div className="trendpro-sort-head">
                          RSI & MACD Trend
                          <span>
                            <FaChevronUp
                              size={10}
                              onClick={sortRecommendationAsc}
                            />
                            <FaChevronDown
                              size={10}
                              onClick={sortRecommendationDesc}
                            />
                          </span>
                        </div>
                      </th>

                      <th>Low</th>
                      <th>High</th>
                      <th>Open</th>
                      <th>Prev Close</th>

                      <th>
                        <div className="trendpro-sort-head">
                          % Change
                          <span>
                            <FaChevronUp size={10} onClick={sortPercentHigh} />
                            <FaChevronDown size={10} onClick={sortPercentLow} />
                          </span>
                        </div>
                      </th>

                      <th>R1</th>
                      <th>S1</th>

                      <th>
                        <div className="trendpro-sort-head">
                          Closing Strength <InfoTooltip text={closeStrength} />
                          <span>
                            <FaChevronUp size={10} onClick={sortClosingHigh} />
                            <FaChevronDown size={10} onClick={sortClosingLow} />
                          </span>
                        </div>
                      </th>

                      <th>
                        <div className="trendpro-sort-head">
                          Rebound Strength{" "}
                          <InfoTooltip text={reboundStrength} />
                          <span>
                            <FaChevronUp size={10} onClick={sortReboundHigh} />
                            <FaChevronDown size={10} onClick={sortReboundLow} />
                          </span>
                        </div>
                      </th>

                      <th>
                        <div className="trendpro-sort-head">
                          Distance to High <InfoTooltip text={distanceToHigh} />
                          <span>
                            <FaChevronUp size={10} onClick={sortDistanceHigh} />
                            <FaChevronDown
                              size={10}
                              onClick={sortDistanceLow}
                            />
                          </span>
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {trendTableData
                      ?.filter((stock) => {
                        if (filter === "All") return true;
                        return normalizeSignal(stock?.prediction) === filter;
                      })
                      ?.map((stock) => {
                        // const ltp = histData?.close?.at(-1);
                        const ltp = stock?.trend_metrics?.ltp;
                        const prevClose = stock?.prev_close;
                        const low = stock?.trend_metrics?.low;
                        const high = stock?.trend_metrics?.high;
                        const open = stock?.trend_metrics?.open;

                        const r1 = stock?.resDaily?.classic?.R1;
                        const s1 = stock?.resDaily?.classic?.S1;

                        const symbol = stock?.symbol;
                        const company = stock?.company;
                        const security_id = stock?.security_id;

                        const range = high && low ? high - low : 0;

                        const change =
                          prevClose && ltp
                            ? Number(
                                (((ltp - prevClose) / prevClose) * 100).toFixed(
                                  2,
                                ),
                              )
                            : null;

                        // const closingStrength =
                        //   range && ltp
                        //     ? Number((((ltp - low) / range) * 100).toFixed(2))
                        //     : null;
                        const closingStrength =
                          stock?.trend_metrics?.closingStrength;

                        // const reboundStrengthValue =
                        //   range && ltp && open
                        //     ? Number(
                        //         (
                        //           ((Math.min(ltp, open) - low) / range) *
                        //           100
                        //         ).toFixed(2),
                        //       )
                        //     : null;
                        const reboundStrengthValue =
                          stock?.trend_metrics?.closingStrength;

                        const distanceHigh =
                          stock?.trend_metrics?.distanceToHigh;
                        // range && ltp
                        //   ? Number((((high - ltp) / range) * 100).toFixed(2))
                        //   : null;

                        const signal = normalizeSignal(stock?.prediction);

                        return (
                          <tr
                            key={symbol}
                            onClick={() =>
                              navigate(`/stockdetail/${symbol}/${security_id}`)
                            }
                          >
                            <td>
                              <div className="trendpro-company">
                                <small>{company}</small>
                                <strong>{symbol}</strong>
                              </div>
                            </td>

                            <td className="trendpro-price">₹{ltp ?? "-"}</td>

                            <td>
                              <span
                                className={`trendpro-badge ${
                                  signal === "Bullish"
                                    ? "bull"
                                    : signal === "Bearish"
                                      ? "bear"
                                      : "neutral"
                                }`}
                              >
                                {stock?.prediction || "Refreshing"}
                              </span>
                            </td>

                            <td>₹{low ?? "-"}</td>
                            <td>₹{high ?? "-"}</td>
                            <td>₹{open ?? "-"}</td>
                            <td>₹{prevClose ?? "-"}</td>

                            <td>
                              <span
                                className={
                                  change >= 0
                                    ? "trendpro-green"
                                    : "trendpro-red"
                                }
                              >
                                {change !== null ? `${change}%` : "-"}
                              </span>
                            </td>

                            <td className="trendpro-green">
                              {r1 ? `₹${Number(r1).toFixed(2)}` : "-"}
                            </td>

                            <td className="trendpro-red">
                              {s1 ? `₹${Number(s1).toFixed(2)}` : "-"}
                            </td>

                            <td
                              style={{
                                color:
                                  closingStrength !== null
                                    ? checkPercent(closingStrength)
                                    : "#64748b",
                                fontWeight: 800,
                              }}
                            >
                              {closingStrength !== null
                                ? `${closingStrength}%`
                                : "-"}
                            </td>

                            <td
                              style={{
                                color:
                                  reboundStrengthValue !== null
                                    ? checkValues(reboundStrengthValue)
                                    : "#64748b",
                                fontWeight: 800,
                              }}
                            >
                              {reboundStrengthValue !== null
                                ? `${reboundStrengthValue}%`
                                : "-"}
                            </td>

                            <td
                              style={{
                                color:
                                  distanceHigh !== null
                                    ? distanceToHighValues(distanceHigh)
                                    : "#64748b",
                                fontWeight: 800,
                              }}
                            >
                              {distanceHigh !== null ? `${distanceHigh}%` : "-"}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </section>

            <div className="stock-table-container">
              <section className="trendpro-mobile-list">
                <div className="trendpro-mobile-head">
                  <h2>{selectedIndex} EOD Trend</h2>
                </div>
                {trendTableData
                  ?.filter((stock) => {
                    if (filter === "All") return true;
                    return normalizeSignal(stock?.prediction) === filter;
                  })
                  ?.map((stock) => {
                    const histData = stock?.hist_data;

                    const ltp = histData?.close?.at(-1);
                    const prevClose = histData?.close?.at(-2);
                    const low = histData?.low?.at(-1);
                    const high = histData?.high?.at(-1);
                    const open = histData?.open?.at(-1);

                    const r1 = stock?.resDaily?.classic?.R1;
                    const s1 = stock?.resDaily?.classic?.S1;

                    const symbol = stock?.symbol;
                    const company = stock?.company;
                    const security_id = stock?.security_id;

                    const range = high && low ? high - low : 0;

                    const percentChange =
                      prevClose && ltp
                        ? Number(
                            (((ltp - prevClose) / prevClose) * 100).toFixed(2),
                          )
                        : null;
                    const isPositive = percentChange > 0;
                    const changeColor =
                      percentChange > 0
                        ? "#249966"
                        : percentChange < 0
                          ? "#f87171"
                          : "#64748b";

                    const closingStrength =
                      range && ltp
                        ? Number((((ltp - low) / range) * 100).toFixed(2))
                        : null;

                    const reboundStrengthValue =
                      range && ltp && open
                        ? Number(
                            (
                              ((Math.min(ltp, open) - low) / range) *
                              100
                            ).toFixed(2),
                          )
                        : null;

                    const distanceHigh =
                      range && ltp
                        ? Number((((high - ltp) / range) * 100).toFixed(2))
                        : null;

                    const signal = normalizeSignal(stock?.prediction);

                    return (
                      <div
                        key={symbol}
                        className="trendpro-mobile-card"
                        onClick={() =>
                          navigate(`/stockdetailpage/${symbol}/${security_id}`)
                        }
                      >
                        <div className="trendpro-mobile-head">
                          <div className="mobile-head-trendpro">
                            <span className="trendpro-company">{company}</span>
                            <h3>{symbol}</h3>
                          </div>

                          <div className="trendpro-mobile-price">
                            <div
                              className="trendpro-mobile-subprice"
                              style={{
                                background: isPositive ? "#ecfdf5" : "#fef2f2",

                                border: `1px solid ${isPositive ? "#86efac" : "#fca5a5"}`,
                              }}
                            >
                              <span
                                className={`trendpro-mobile-ltp ${isPositive ? "index-chip-green" : "index-chip-red"}`}
                              >
                                ₹{ltp ?? "-"}
                              </span>

                              <div
                                className={`trendpro-mobile-change ${
                                  percentChange >= 0 ? "positive" : "negative"
                                }`}
                              >
                                {percentChange >= 0 ? (
                                  <IoMdTrendingUp />
                                ) : (
                                  <IoMdTrendingDown />
                                )}

                                <span
                                  className={
                                    isPositive
                                      ? "index-chip-green"
                                      : "index-chip-red"
                                  }
                                >
                                  {ltp - prevClose > 0
                                    ? `+${(ltp - prevClose).toFixed(2)}`
                                    : (ltp - prevClose).toFixed(2)}
                                </span>

                                <span
                                  className={
                                    isPositive
                                      ? "index-chip-green"
                                      : "index-chip-red"
                                  }
                                  style={{ color: changeColor }}
                                >
                                  (
                                  {percentChange > 0
                                    ? `+${percentChange}`
                                    : percentChange}
                                  %)
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="trendpro-mobile-grid">
                          <div>
                            <span>RSI & MACD</span>
                            <b>
                              <span
                                className={`trendpro-badge ${
                                  signal === "Bullish"
                                    ? "bull"
                                    : signal === "Bearish"
                                      ? "bear"
                                      : "neutral"
                                }`}
                              >
                                {stock?.prediction || "Refreshing"}
                              </span>
                            </b>
                          </div>
                          {/* <div>
                          <span>% Change</span>
                          <b
                            className={
                              percentChange >= 0
                                ? "trendpro-green"
                                : "trendpro-red"
                            }
                          >
                            {percentChange !== null ? `${percentChange}%` : "-"}
                          </b>
                        </div> */}

                          <div>
                            <span>Open</span>
                            <b>₹{open ?? "-"}</b>
                          </div>

                          <div>
                            <span>High</span>
                            <b>₹{high ?? "-"}</b>
                          </div>

                          <div>
                            <span>Low</span>
                            <b>₹{low ?? "-"}</b>
                          </div>

                          <div>
                            <span>Prev Close</span>
                            <b>₹{prevClose ?? "-"}</b>
                          </div>

                          <div>
                            <span>R1</span>
                            <b className="trendpro-green">
                              {r1 ? `₹${Number(r1).toFixed(2)}` : "-"}
                            </b>
                          </div>

                          <div>
                            <span>S1</span>
                            <b className="trendpro-red">
                              {s1 ? `₹${Number(s1).toFixed(2)}` : "-"}
                            </b>
                          </div>

                          <div>
                            <span>Closing Strength</span>
                            <b>
                              {closingStrength !== null
                                ? `${closingStrength}%`
                                : "-"}
                            </b>
                          </div>

                          <div>
                            <span>Rebound Strength</span>
                            <b>
                              {reboundStrengthValue !== null
                                ? `${reboundStrengthValue}%`
                                : "-"}
                            </b>
                          </div>

                          <div>
                            <span>Distance to High</span>
                            <b>
                              {distanceHigh !== null ? `${distanceHigh}%` : "-"}
                            </b>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </section>
            </div>
          </>
        )}
      </main>
    </>
  );
};

export default TrendAnalysis;
